import { render } from "./SideBarList.vue?vue&type=template&id=313d8c2f&scoped=true"
import script from "./SideBarList.vue?vue&type=script&lang=js"
export * from "./SideBarList.vue?vue&type=script&lang=js"

import "./SideBarList.vue?vue&type=style&index=0&id=313d8c2f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313d8c2f"]])

export default __exports__